<template>
  <div v-if="!loading">
    <div class="wui-container house-detail" v-if="info?.houseStatus !== 0">
      <!-- swiper -->
      <Swiper type="house" :video="info.video" :imgs="info.imgs" :height=400></Swiper>

      <!-- 用户信息 -->
      <div class="user">
        <router-link :to="`/user/${info.userId}`" class="user-base">
          <i class="iconfont icon-MoreArrow"></i>
          <div class="avatar">
            <img v-if="userInfo.avatar" :src="util.thumb(userInfo.avatar, 200, 240)">
          </div>

          <div class="base-other">
            <div class="name">
              <span>{{userInfo.name}}</span>
            </div>
            <div>
              <div class="other">
                <i v-if="userInfo.gender == 1" class="iconfont icon-man"></i>
                <i v-if="userInfo.gender == 2" class="iconfont icon-woman1"></i>
                <span class="dot" v-if="userInfo.age !== 0 && userInfo.gender > 0">·</span>
                <span class="age" v-if="userInfo.age !== 0">{{userInfo.age}}</span>
                <span class="dot" v-if="userInfo.from">·</span>
                <span class="from">{{userInfo.from}}</span>
              </div>
            </div>
            <div class="language">
              <span>{{util.join(userInfo.languages, ' · ')}}</span>
            </div>
          </div>
        </router-link>
        <div class="user-introduce">
          <img src="@/assets/img/quote.svg">
          <div class="introduce" v-html="info.personalDesc || userInfo.introduce"></div>
        </div>
      </div>

      <van-tabs class="main" v-model:active="tabActive" scrollspy sticky>
        <van-tab :title="$t('概况')">
          <div class="house-base">
            <div class="rented" v-if="info.status == 5">
              <i class="iconfont icon-Rented"></i>
              <span>{{$t('已出租')}}</span>
            </div>

            <div class="house-config">
              <div class="config-item">
                <div class="config-tit">{{$t('租金')}}</div>
                <div class="config-val pv-config">
                  <div>{{info.rent}}{{info.currencyUnit}}/{{$t('月')}}</div>
                  <div class="pv"><i class="iconfont icon-View"></i>{{info.viewCount}}</div>
                </div>
              </div>
              <div class="config-item">
                <div class="config-tit">{{$t('类型')}}</div>
                <div class="config-val">{{info.rentType}}/{{info.timeType}}</div>
              </div>
              <div class="config-item">
                <div class="config-tit">{{$t('房间')}}</div>
                <div class="config-val">{{info.bedroom}}{{$t('卧室')}},{{info.bathroom}}{{$t('洗手间')}}</div>
              </div>
              <div class="config-item">
                <div class="config-tit">{{$t('地铁')}}</div>
                <div class="config-val">{{info.subways}}</div>
              </div>
            </div>
            <div class="house-type">
              <div class="type-item">
                <div class="type-val">{{info.deposit}}{{info.currencyUnit}}</div>
                <div class="type-tit">{{$t('押金')}}</div>
              </div>
              <div class="type-item">
                <div class="type-val">{{info.area}}{{info.areaUnit}}</div>
                <div class="type-tit">{{$t('面积')}}</div>
              </div>
              <div class="type-item">
                <div class="type-val">{{info.floor}}</div>
                <div class="type-tit">{{$t('楼层')}}</div>
              </div>
            </div>
            <div class="house-tags" v-if="info.tags && info.tags.length > 0">
              <div class="tag" v-for="(item, index) in info.tags" :key="index">
                <span>{{item}}</span>
              </div>
            </div>
          </div>
        </van-tab>

        <van-tab :title="$t('描述')">
          <div class="house-intro">
            <div class="title">{{$t('描述')}}</div>
            <div class="intro-txt" v-html="info.desc"></div>
          </div>
        </van-tab>

        <van-tab :title="$t('设施')">
          <div class="house-facility">
            <div class="title">{{$t('设施')}}</div>
            <div class="house-list">
              <div class="house-list-top" v-for="(item, index) in info.devices" :key="index">
                <div class="house-list-icon">
                  <img :src="item.icon">
                </div>
                <span>{{item.name}}</span>
              </div>
            </div>
          </div>
        </van-tab>

        <van-tab :title="$t('地图')">
          <div class="house-position">
            <div class="title">{{$t('地图')}}</div>
            <div class="house-address">
              <span class="txt">{{info.city}} {{info.district}} {{info.address}}</span>
            </div>
            <div class="house-position-map">
              <iframe 
                :src="mapUrl" 
                frameborder="0" 
                v-if="mapUrl"
                allow="geolocation; microphone; camera"
                allowfullscreen
                loading="eager"
                referrerpolicy="no-referrer-when-downgrade"
                sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                @load="onMapLoad"
              ></iframe>
            </div>
          </div>
        </van-tab>

      </van-tabs>

      <!-- 底部 -->
      <div class="btn-action">
        <div class="btn-collect" @click="$downloadApp('houseDetail', {houseId: id})">
          <span class="iconfont icon-1xin"></span>
          <span class="num">{{info.collectCount || 0}}</span>
        </div>
        <div class="btn btn-message" @click="$downloadApp('houseDetail', {houseId: id})" >
          <span class="iconfont icon-Booking"></span>
          <span>{{$t('线上签约')}}</span>
        </div>
        <div class="btn btn-sign" @click="$downloadApp('houseDetail', {houseId: id})">
          <span class="iconfont icon-Chat"></span>
          <span>{{$t('私信')}}</span>
        </div>
      </div>

      <HomeButton bottom="80px"></HomeButton>
    </div>
    <Empty v-else/>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from "vue-router";
import { Tab, Tabs } from 'vant';

import api from "@/api/index";
import Swiper from "@/components/Swiper.vue";
import HomeButton from "@/components/HomeButton.vue";

import { initWechatJSSDK } from "@/assets/wechat.js"
import Empty from "@/components/Empty.vue";

export default {
    components: {
      Empty,
        Swiper,
        VanTabs: Tabs,
        VanTab: Tab,
        HomeButton,
    },
    setup() {
        const tabActive = ref(0);
        return { tabActive };
    },
    data() {
        return {
            id: '',
            info: {},
            userInfo: {},
            loading:false,
            mapUrl:''
        };
    },
    mounted() {
        const route = useRoute();
        this.id = route.params.id;
        this.getHouseInfo();
        window.scrollTo(0,0);
    },
    computed:{

    },
    methods: {
      setMapUrl(){
        let { longitude, latitude } = this.info;
        if(!longitude || !latitude) return;
        let host = 'https://www.wellcee.com'
        if (location.host !== host) {
          host = 'https://test.well-see.com'
        }
        let url = `/index/house/map?longitude=${ longitude }&latitude=${ latitude }`;
        this.mapUrl = host + url;
        
        // 针对 iOS 的特殊处理，延迟触发地图加载
        this.$nextTick(() => {
          this.forceMapLoad();
        });
      },
      onMapLoad() {
        console.log('地图加载完成');
      },
      forceMapLoad() {
        // 强制触发 iframe 加载，解决 iOS 延迟加载问题
        setTimeout(() => {
          const iframe = this.$el.querySelector('.house-position-map iframe');
          if (iframe && this.mapUrl) {
            // 通过重新设置 src 来强制加载
            const currentSrc = iframe.src;
            iframe.src = '';
            setTimeout(() => {
              iframe.src = currentSrc;
            }, 10);
          }
        }, 100);
      },
        getHouseInfo(){
            this.loading = true;
            api.house.getInfo({
                ...this.util.getUrlSearch(),
                id: this.id,
            }).then((res)=>{
                if(res.data.dailyRent) {
                    res.data.tags.push(res.data.dailyRent);
                }
                this.info = res.data;
                this.userInfo = res.data.userInfo;

                this.info.subways =this.info?.subways?.length ? this.info.subways.map(item => item.name).join(', ') : "";
                this.info.tags = this.info?.tags?.length ? this.info.tags.map(item => item.name) : [];
                this.setMapUrl();
              if(res.data.houseStatus === 0){
                  document.title = "内容已关闭"
                }else{
                  document.title = `${this.info.city}-${this.info.district} ${this.info.rentType} · ${this.info.timeType} · ${this.info.tags.join(' · ')}`;
                }
                initWechatJSSDK({
                    title: `${this.info.city}-${this.info.district} ${this.info.rentType} · ${this.info.timeType} · ${this.info.tags.join(' · ')}`,
                    desc: this.info.personalDesc,
                    imgUrl: this.info.imgs[0]
                });
            }).finally(()=>{
               this.loading = false;
            })
        }
    },
};
</script>

<style>
.house-detail .van-tabs__nav{
    border-radius: 15px 15px 0 0;
}
.van-tabs--line .van-tabs__wrap{
    height: 50px;
    border-bottom: 1px solid #f8f8f8;
}
.van-tab{
    font-size: 15px;
    color: #111111;
}
.van-tabs__line{
    width: 18px;
    height: 2px;
    background: #111111;
    border-radius: 2px;
}
.van-sticky--fixed{
    max-width: 500px;
    margin: 0 auto;
}
</style>
<style scoped>
.house-detail{
    padding-bottom: 81px;
}
.house-detail .main{
    margin-top: 10px;
}

.house-base{
    padding: 0 15px 15px 15px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 0 0 15px 15px;
}
.house-detail .rented {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 -15px;
    height: 40px;
    background: rgba(224, 175, 1, .1);

    font-weight: 500;
    font-size: 14px;
    color: #E0AF01;
}
.house-detail .rented .iconfont{
    margin-right: 6px;
    font-size: 20px;
}

.house-config{
    padding-top: 20px;
}
.house-config .config-item {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 24px;
}
.house-config .config-item:last-child{
    margin-bottom: 0;
}
.house-config .config-item .config-tit{
    width: 58px;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
}
.house-config .config-item .config-val{
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
}
.house-config .config-item .pv-config{
    display: flex;
    justify-content: space-between;
}
.house-config .config-item .pv-config .pv{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
}
.house-config .config-item .pv-config .pv .iconfont{
    margin-right: 4px;
}

.house-detail .house-type {
    margin-top: 20px;
    background-color: rgba(248, 248, 248, 0.5);
    display: flex;
    height: 66px;
    padding: 0 0 0 30px;
    border-radius: 15px;
}
.house-detail .type-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-right: 30px;
}
.house-detail .type-item:last-child{
    margin-right: 0;
}
.house-detail .type-val {
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
    color: #111111;
    margin-bottom: 4px;
}
.house-detail .type-item .type-tit {
    font-size: 12px;
    line-height: 17px;
    color: #111111;
}
.house-detail .house-tags {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
}
.house-detail .house-tags .tag {
    padding: 3px 7px;
    border: 1px solid rgba(17, 17, 17, 0.03);
    box-sizing: border-box;
    border-radius: 6px;
    margin: 0 10px 10px 0;
    font-size: 12px;
    color: #666666;
}

.house-intro .title,
.house-facility .title,
.house-position .title {
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
    color: #111111;
    margin-bottom: 10px;
}
.house-intro{
    padding: 20px 15px 20px 15px;
    background-color: #fff;
    margin: 10px 0 10px 0;
    border-radius: 15px;
}
.house-intro .intro-txt {
    word-wrap: break-word;
    font-size: 14px;
    line-height: 24px;
    white-space: pre-wrap;
}

.house-facility {
    background-color: #fff;
    padding: 20px 15px;
    border-radius: 15px;
}
.house-facility .house-list {
    display: flex;
    flex-wrap: wrap;
    background-color: #FCFCFC;
    padding-bottom: 10px;
}
.house-facility .house-list-top {
    width: 25%;
    font-size: 12px;
    color: #666;
    text-align: center;
    margin-top: 10px;
}
.house-facility .house-list .house-list-icon {
    position: relative;
    width: 40%;
    padding-bottom: 40%;
    margin: 0 auto;
    margin-top: 4px;
    margin-bottom: 9px;
}
.house-facility .house-list .house-list-icon img {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}

.house-position {
    padding: 20px 15px 20px 15px;
    background-color: #fff;
    margin: 10px 0 0 0;
    border-radius: 15px;
}
.house-position .house-address{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.house-position .house-address .txt {
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
}
.house-position .house-address .iconfont{
    font-size: 14px;
    color: #666;
}
.house-position .house-position-map {
    width: 100%;
    height: 400px;
    display: flex;
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    background-color: #f5f5f5;
}
.house-position .house-position-map iframe{
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 8px;
    /* iOS 兼容性样式 */
    -webkit-overflow-scrolling: touch;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    will-change: transform;
}

.user {
    position: relative;
    padding-bottom: 15px;
    background-color: #fff;
    border-radius: 15px;
    margin-top: -15px;
}
.user .user-base {
    position: relative;
    display: flex;
    padding: 21px 15px 10px 15px;
}
.user .icon-MoreArrow {
    position: absolute;
    top: 30px;
    right: 23px;
    color: #000000;
    font-size: 20px;
}
.user .avatar {
    height: 70px;
    width: 70px;
    margin-right: 12px;
    border-radius: 2px;
    background-color: #f5f5f5;
}
.user .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 2px;
}
.user .base-other {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.user .base-other .name {
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    color: #111111;
}
.user .base-other .other {
    display: inline-flex;
    align-items: center;
    height: 23px;
    padding: 0 5px;
    background: rgba(17, 17, 17, 0.03);
    border-radius: 6px;

    font-size: 12px;
    color: #111111;
}
.user .base-other .other .dot{
    padding: 0 4px;
}
.user .base-other .other .iconfont{
    font-size: 14px;
    line-height: 1;
    padding-left: 2px;
}
.user .base-other .language {
    font-size: 12px;
    line-height: 17px;
    color: #111111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.user .user-introduce {
    position: relative;
    padding: 15px;
    margin: 0 15px;
    background: rgba(248, 248, 248, 0.4);
    border-radius: 15px;
}
.user .user-introduce img{
    position: absolute;
    top: 15px;
    right: 15px;
    width: 20px;
    height: 15px;
}
.user .user-introduce .introduce{
    font-size: 14px;
    line-height: 20px;
    color: #111111;
}


.btn-action {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 12px 15px;
    display: flex;
    background-color: #fff;
    box-shadow: inset 0 1px 0 0 #f8f8f8;
    z-index: 1001;
    max-width: 500px;
    margin: 0 auto;
}
.btn-action .btn-collect {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30px;
    margin-right: 19px;
}
.btn-action .btn-collect .iconfont{
    font-size: 24px;
    line-height: 1;
}
.btn-action .btn-collect .icon-CollectFill{
    color: #2DB6B4;
}
.btn-action .btn-collect .num{
    font-size: 12px;
    line-height: 17px;
}
.btn-action .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    height: 47px;
    background: #2DB6B4;
    border-radius: 6px;
}
.btn-action .btn .iconfont{
    font-size: 20px;
    margin-right: 10px;
}
.btn-action .btn span {
    font-size: 18px;
    color: #FFFFFF;
}
.btn-action .btn-message{
    margin-right: 12px;
}
</style>
